import FieldSet from '../../FieldSet';

import { AssigneeImage } from './AssigneeImage';
import { AssigneeName } from './AssigneeName';

export class AssigneeFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [AssigneeImage, AssigneeName];
  }

  get title() {
    return 'Assignee';
  }
}
